const HeadingPage = ({ title }: { title: string }) => {
  return (
    <div className="flex items-center text-4xl font-semibold">
      <h3>{title}</h3>
    </div>
  );
};

export default HeadingPage;
